import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  modalContent: {
    position: "relative",
    overflowY: "auto",
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
    margin: "0 auto",
    maxWidth: [theme.breakpoints.values.xl],
    [theme.breakpoints.down("lg")]: {
      margin: "0 20px",
    },
  },
}));
